var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCypress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M128,0 C198.749091,0 256,57.2509091 256,128 C256,198.749091 198.749091,256 128,256 C57.2509091,256 0,198.749091 0,128 C0,57.2509091 57.2509091,0 128,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,3 C197.090909,3 253,58.9090909 253,128 C253,197.090909 197.090909,253 128,253 C58.9090909,253 3,197.090909 3,128 C3,58.9090909 58.9090909,3 128,3 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-2.4%",
    y: "-2.4%",
    width: "104.8%",
    height: "104.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000000",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M128,7.38596491 C194.666667,7.38596491 248.614035,61.3333333 248.614035,128 C248.614035,194.666667 194.666667,248.614035 128,248.614035 C61.3333333,248.614035 7.38596491,194.666667 7.38596491,128 C7.38596491,61.3333333 61.3333333,7.38596491 128,7.38596491 Z",
    fill: "#5C5C5E",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.035088,181.070175 C187.649123,194.666667 181.070175,204.754386 171.859649,212.210526 C162.649123,219.666667 150.368421,223.614035 135.017544,224.929825 L131.947368,204.754386 C142.035088,203.438596 149.491228,201.245614 154.315789,197.736842 C156.070175,196.421053 159.578947,192.473684 159.578947,192.473684 L123.175439,75.8070175 L153.438596,75.8070175 L174.491228,163.087719 L196.859649,75.8070175 L226.245614,75.8070175 L192.035088,181.070175 Z M86.3333333,71.8596491 C93.3508772,71.8596491 99.9298246,72.7368421 105.192982,74.9298246 C110.894737,77.122807 116.157895,80.1929825 121.421053,84.5789474 L109.140351,101.245614 C105.631579,98.6140351 102.122807,96.8596491 99.0526316,95.5438596 C95.9824561,94.2280702 92.0350877,93.7894737 88.5263158,93.7894737 C73.6140351,93.7894737 66.1578947,105.192982 66.1578947,128.438596 C66.1578947,140.280702 67.9122807,148.614035 71.8596491,153.438596 C75.8070175,158.701754 81.0701754,160.894737 88.5263158,160.894737 C92.0350877,160.894737 95.5438596,160.45614 98.6140351,159.140351 C101.684211,157.824561 105.192982,156.070175 109.578947,153.438596 L121.859649,170.982456 C111.77193,179.315789 100.368421,183.263158 87.2105263,183.263158 C76.6842105,183.263158 67.9122807,181.070175 60.0175439,176.684211 C52.5614035,172.298246 46.4210526,165.719298 42.4736842,157.385965 C38.5263158,149.052632 36.3333333,139.403509 36.3333333,128 C36.3333333,117.035088 38.5263158,106.947368 42.4736842,98.6140351 C46.4210526,89.8421053 52.5614035,83.2631579 60.0175439,78.4385965 C67.4736842,74.4912281 76.245614,71.8596491 86.3333333,71.8596491 Z",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCypress);
export default __webpack_public_path__ + "static/media/cypress.71a7ec45b07651a4b0f3893ba8a19faa.svg";
export { ForwardRef as ReactComponent };